import React, { createRef } from "react";
import PropTypes from "prop-types";
import { AsyncTypeahead } from "react-bootstrap-typeahead";

import WebsiteService from "services/WebsiteService";

/**
 * Typeahead component for searching for Websites
 * @component
 */
class WebsiteSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedIds: [],
        };
        this.ref = createRef();
    }

    handleSearch = (query) => {
        this.setState({
            isLoading: true,
        });

        const countryId = this.props.countryId;
        const enabledWebSitesOnly = this.props.enabledWebSitesOnly;
        WebsiteService.typeahead(query, countryId, enabledWebSitesOnly).then(
            (options) => {
                if (options === null) {
                    // this request was canceled due to a change in the typeahead component
                    return;
                }
                const list =
                    this.props.skip.length > 0
                        ? options.filter(
                              (row) => this.props.skip.indexOf(row.id) === -1
                          )
                        : options;

                this.setState({
                    options: list,
                    isLoading: false,
                });
            }
        );
    };

    clear = () => {
        this.ref.current.clear();
    };

    /**
     * AsyncTypeahead seems to have a bug which is allowing the same option to be selected multiple times
     * so we need to keep track of the selected values uppon selection to get ride of the duplicates
     */
    handleOnChange = (selected) => {
        this.setState(
            {
                selectedIds: selected.map((option) => option.id),
                options: [],
            },
            () => {
                this.props.onChange(selected);
            }
        );
    };

    render() {
        const filterBy = () => true;

        const onChange = this.props.multiple
            ? this.handleOnChange
            : this.props.onChange;

        return (
            <AsyncTypeahead
                {...this.state}
                filterBy={filterBy}
                labelKey="display_name"
                ref={this.ref}
                id="website-search"
                maxResults={10}
                minLength={2}
                disabled={this.props.disabled}
                multiple={this.props.multiple}
                defaultSelected={this.props.defaultSelected}
                defaultInputValue={this.props.defaultInputValue}
                onSearch={this.handleSearch}
                onChange={onChange}
                placeholder={this.props.placeholder}
                renderMenuItemChildren={(option, props) => (
                    <div
                        key={`m${option.id}`}
                        className={`websiteActive${option.is_active}`}
                    >
                        <span className="colHead">id:</span>
                        <span className="colValue">{option.id}</span>
                        <span className="colHead">name:</span>
                        <span className="colValue">{option.name}</span>
                        <span className="colHead">hostname:</span>
                        <span className="colValue">{option.display_name}</span>
                    </div>
                )}
                useCache={false}
            />
        );
    }
}

WebsiteSearch.propTypes = {
    /**  */
    onChange: PropTypes.func.isRequired,
    skip: PropTypes.arrayOf(PropTypes.number),
    placeholder: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    multiple: PropTypes.bool,
    enabledWebSitesOnly: PropTypes.bool,
    countryId: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
};

WebsiteSearch.defaultProps = {
    disabled: false,
    onChange: (values) => {
        console.log("Website has changed", values);
    },
    skip: [],
    placeholder: "Search for a website...",
    multiple: false,
    countryId: null,
    enabledWebSitesOnly: true,
};

export default WebsiteSearch;
